import { SessionStorageItemTypes } from "./constants";
import type { SessionStorageItems, SessionStorageService } from "./types";

const SessionStorage: SessionStorageService = {
  get: (key) => {
    try {
      const value = sessionStorage.getItem(key);

      if (value === null) {
        return null;
      }

      if (SessionStorageItemTypes[key] === "string") {
        return value as unknown as SessionStorageItems[typeof key];
      }
      if (SessionStorageItemTypes[key] === "number") {
        return Number(value) as unknown as SessionStorageItems[typeof key];
      }
      if (SessionStorageItemTypes[key] === "boolean") {
        return (value === "true") as unknown as SessionStorageItems[typeof key];
      }
      if (SessionStorageItemTypes[key] === "object") {
        return JSON.parse(value) as SessionStorageItems[typeof key];
      }

      throw new Error("Unsupported value type");
    } catch {
      return null;
    }
  },

  set: (key, value) => {
    try {
      const type = SessionStorageItemTypes[key];

      let valueToStore: string;
      if (type === "string") {
        if (typeof value !== "string") {
          throw Error("String value expected");
        }
        valueToStore = value;
      } else if (type === "number") {
        if (typeof value !== "number") {
          throw Error("Number value expected");
        }
        valueToStore = (value as number).toString();
      } else if (type === "boolean") {
        if (typeof value !== "boolean") {
          throw Error("Boolean value expected");
        }
        valueToStore = (value as boolean).toString();
      } else if (type === "object") {
        valueToStore = JSON.stringify(value);
      } else {
        throw new Error("Unsupported value type");
      }

      sessionStorage.setItem(key, valueToStore);
    } catch {
      // Ignore quota / private mode errors.
    }
  },

  remove: (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // Ignore storage errors.
    }
  },

  clear: () => {
    const keys = Object.keys(SessionStorageItemTypes) as Array<
      keyof SessionStorageItems
    >;

    for (const key of keys) {
      SessionStorage.remove(key);
    }
  },
};

export default SessionStorage;
